export abstract class IAuthenticationService {
    abstract authenticate(userId: string, password: string): any;
    abstract getToken(): string;
    abstract getCookie(): string;
    abstract isLoggedIn(): boolean;
    abstract setUserLoggedIn(): void;
    abstract logout(): void;
}
